import { format } from "date-fns";
import { es } from "date-fns/locale";
import { Calendar as CalendarIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export const DateField = ({ label, value, onChange, testId }) => {
  const selected = value ? new Date(value + "T00:00:00") : undefined;
  return (
    <div className="flex flex-col gap-1">
      <label className="text-[10px] uppercase tracking-widest font-semibold text-muted-foreground">
        {label}
      </label>
      <Popover>
        <PopoverTrigger asChild>
          <Button
            variant="outline"
            data-testid={testId}
            className="w-[150px] rounded-none border-border h-9 justify-start gap-2 font-normal text-sm"
          >
            <CalendarIcon className="w-3.5 h-3.5 shrink-0 text-muted-foreground" />
            {selected ? (
              format(selected, "dd/MM/yyyy", { locale: es })
            ) : (
              <span className="text-muted-foreground">dd/mm/aaaa</span>
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0 rounded-none" align="start">
          <Calendar
            mode="single"
            selected={selected}
            onSelect={(d) => onChange(d ? format(d, "yyyy-MM-dd") : "")}
            locale={es}
            initialFocus
          />
          {value && (
            <button
              data-testid={`${testId}-clear`}
              onClick={() => onChange("")}
              className="w-full py-2 text-xs uppercase tracking-wide font-medium border-t border-border hover:bg-muted transition-colors"
            >
              Borrar fecha
            </button>
          )}
        </PopoverContent>
      </Popover>
    </div>
  );
};
